import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export function useIAFinanciera() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [month, setMonth] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  });

  const fetchAnalysis = useCallback(async () => {
    setLoading(true);
    try {
      const res = await authAxiosRef.current.get(`/financiero/ai-analysis?month=${month}`);
      setData(res.data);
    } catch {
      toast.error("Erro ao carregar analise");
    }
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [month]); // month is intentional: refetch when user changes month

  useEffect(() => { fetchAnalysis(); }, [fetchAnalysis]);

  const formatPrice = (v) =>
    `${(v || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ".")} EUR`;

  return { data, loading, month, setMonth, formatPrice };
}
